<div class="section-title">
    <h3 class="section-title__text">{{ title }}</h3>
    @if (count !== null && count !== undefined) {
        <span class="section-title__count">{{ count }}</span>
    }
</div>
